exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{\r\n    height: 99vh !important; \r\n}\r\n.main-header{\r\n    display: none !important;\r\n}\r\n.main-sidebar{\r\n    display: none !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/playitadmin_frontend/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = main